import { useState } from 'react';
import { Flex, Spinner } from '@optiaxiom/react';

import { useGetAgentsFromDirectory } from '../../hooks/useAgentDirectory';
import { DirectoryAgent } from '../../services/agent-directory';

import { AgentDetailsSidebar } from './AgentDetailsSidebar';
import { MarketplaceAgentsGrid } from './MarketplaceAgentsGrid';

export function MarketPlaceTab() {
  const { agents: directoryAgents, isPending } = useGetAgentsFromDirectory();
  const [selectedAgent, setSelectedAgent] = useState<DirectoryAgent | undefined>(undefined);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleAgentSelect = (agent: DirectoryAgent) => {
    setSelectedAgent(agent);
    setSidebarOpen(true);
  };

  const handleCloseSidebar = () => {
    setSidebarOpen(false);
    setSelectedAgent(undefined);
  };

  if (isPending) {
    return (
      <Flex justifyContent="center" alignItems="center" h="full">
        <Spinner size="xl" />
      </Flex>
    );
  }

  return (
    <>
      <Flex flexDirection="column" gap="24" w="full" h="full" p="16">
        <Flex flexDirection="column" gap="24" w="full" h="full">
          <MarketplaceAgentsGrid
            agents={directoryAgents || []}
            selectedAgent={selectedAgent}
            setSelectedAgent={handleAgentSelect}
          />
        </Flex>
      </Flex>

      <AgentDetailsSidebar agent={selectedAgent} open={sidebarOpen} onClose={handleCloseSidebar} />
    </>
  );
}
